import React, { useEffect, lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "./components/ui/sonner";
import ErrorBoundary from "./ErrorBoundary";
import { LanguageProvider } from "./contexts/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

// Lazy load pages for code splitting
const Home = lazy(() => import("./pages/Home"));
const Contact = lazy(() => import("./pages/Contact"));
const Portfolio = lazy(() => import("./pages/Portfolio"));
const Knowledge = lazy(() => import("./pages/Knowledge"));
const KnowledgeArticle = lazy(() => import("./pages/KnowledgeArticle"));
const Admin = lazy(() => import("./pages/Admin"));

// Minimal loading fallback
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#F7F7F8]">
    <div className="w-8 h-8 border-2 border-[#6CC3B5] border-t-transparent rounded-full animate-spin" />
  </div>
);

function AppContent() {
  return (
    <>
      <Header />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/knowledge" element={<Knowledge />} />
          <Route path="/knowledge/:slug" element={<KnowledgeArticle />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </Suspense>
      <Footer />
      <WhatsAppButton />
      <Toaster />
    </>
  );
}

function App() {
  useEffect(() => {
    // Suppress ResizeObserver errors
    const originalError = window.console.error;
    window.console.error = (...args) => {
      const message = args[0]?.toString?.() || '';
      if (message.includes('ResizeObserver') || message.includes('loop limit exceeded')) return;
      originalError.apply(console, args);
    };
    return () => {
      window.console.error = originalError;
    };
  }, []);

  return (
    <HelmetProvider>
      <ErrorBoundary>
        <LanguageProvider>
          <div className="App">
            <BrowserRouter>
              <AppContent />
            </BrowserRouter>
          </div>
        </LanguageProvider>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
